import React from "react";
import HeroImage from "../assets/experiences/heroImage.jpg";
import { ImArrowRight } from "react-icons/im";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="md:h-auto md:p-12 bg-gradient-to-b from-black via-black to-gray-800 p-12"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center w-full p-12 md:flex-row">
        <div className="flex flex-col justify-center w-1/2 pb-8">
          <h2 className="text-3xl sm:text-5xl font-bold text-white">
            I'm a Software Developer / Software Engineer
          </h2>
          <p className="text-gray-500 py-4 max-w-md">
            "Hi, I'm Kenny Feb Galagar, I enjoy creating software solutions and
            tackling challenging problems."
          </p>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <ImArrowRight size={15} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>

        <div>
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-2xl mx-auto w-1/2"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
